/* template */
<template minapp="mpx" xlang="wxml"><controllable-drawer-bottom :title="(title)" :show="(show)" @close="closeOperateDrawer" :customStyle="({height: '486px'})"><Tab :style='["marginTop: 24px"] | transRpxStyle' :tabKey="(currentSegment)" :tabList="(tabList)" @settabkey="setCurrentSegment" v-if="(isTransfer)"/><div class="order-info-container" v-if="(segmentList[currentSegment])"><template v-if="(hasSegmentOperate(segmentList[currentSegment]))"><div v-for="(order, index) in (segmentList[currentSegment])" :key="order.index" class="order-info" v-if="(hasTicketOperate(order))"><div class="order-info-header"><div class="train-code">{{ order.train_code }}</div><div class="train-station"><span>{{ order.from_station_name }}</span><mpx-image src="https://ut-static.udache.com/webx/sfc/X9HWVKNYaAb2Zu8ZlpcY4.png" class="train-station-icon"/><span>{{ order.to_station_name }}</span></div><div class="train-date">{{ formateDate(order) }}</div></div><mpx-view v-for="(item, index) in (order.tickets_info)" @tap.stop="clickCheckBox(item)" class="ticket-info" v-if="(item.showCheckBox || item.warnText)"><div class="ticket-info-content"><div class="ticket-info-content-top"><div :class="({normal: item.showCheckBox})" class="passenger-name">{{ item.passenger_name }}</div><div class="ticket-type">{{ getPassengerType(item.ticket_type) }}</div><div :class="({normal: item.showCheckBox})" class="ticket-seat">{{ item.seat_type }}</div><div :class="({normal: item.showCheckBox})" class="ticket-seat">{{ getPrice(+item.ticket_price) }}</div></div><div class="ticket-info-content-bottom"><div class="passenger-id-type">{{ item.passenger_id_type_name }}</div><div class="passenger-id-no">{{ item.passenger_id_no }}</div></div></div><div class="ticket-info-operate"><span v-if="(item.warnText)">{{ item.warnText }}</span><Checkbox :ref='("checkbox"+(item.ticket_id))' :disabled="(currentOrder && order.order_id !== currentOrder)" :checkboxKey="(item.ticket_id)" :checkedProp="currentTikcet" mpxModelEvent="input" @mpxModel='__model("currentTikcet", $event, ["value"], undefined)' @checkedChange="checkedChange" @disableClick="disableClick" v-else-if="(item.showCheckBox)"/></div></mpx-view></div></template><div class="default-status" v-else><mpx-image src="https://ut-static.udache.com/webx/sfc/QKgKAHz74IY325JSG2_VF.png" class="default-status-icon"/><div class="default-status-text">{{defaultText}}</div></div></div><div class="footer"><mpx-view :class="(!hasChecked && 'disabled')" @tap="operate" class="operate-button">{{ buttonText }}</mpx-view></div></controllable-drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mec3e5310"}'>
  .order-info-container
    flex 1
    margin-top 15px
    padding 0 16px
    display flex
    flex-direction column
    overflow auto
    .order-info
      display flex
      flex-direction column
      margin-bottom 14px
      &-header
        display flex
        align-items center
        flex-wrap wrap
        margin-bottom 12px
        .train-code
          font-family PingFangSC-Medium
          font-size 15px
          font-weight 500
          line-height 15px
          color #222
          margin-right 4px
        .train-station
          display flex
          font-family PingFangSC-Medium
          font-size 15px
          font-weight 500
          line-height 15px
          color #222
          align-items center
          margin-right 8px
          &-icon
            height 4px
            width 14px
            margin 0 4px
        .train-date
          font-size 13px
          font-weight 400
          font-family PingFangSC-Regular
          line-height 13px
          color #666
      .ticket-info
        display flex
        justify-content space-between
        align-items center
        padding 20px 16px
        border-radius 10px
        background #F6F9FD
        margin-bottom 10px
        &-content
          display flex
          flex-direction column
          &-top
            display flex
            align-items center
            color #999
            .passenger-name
              font-family PingFangSC-Medium
              font-size 15px
              font-weight 500
              line-height 15px
              &.normal
                color #222
            .ticket-type
              position relative
              padding 2px
              margin-left 5.5px
              border-radius 3px
              font-size 10px
              font-weight 400
              line-height 10px
              text-align center
              color #999
              &::after
                position absolute
                content ''
                width 200%
                height 200%
                box-sizing border-box
                border 1px solid #ccc
                transform-origin 0 0
                transform scale(0.5)
                border-radius 6px
                top 0
                left 0
            .ticket-seat, .ticket-price
              font-size 13px
              font-family PingFangSC-Regular
              font-weight 400
              line-height 13px
              margin-left 6px
              &.normal
                color #666
            .ticket-price
              margin-left 1px
          &-bottom
            display flex
            font-size 12px
            font-weight 400
            line-height 12px
            color #999999
            margin-top 10px
            .passenger-id-no
              margin-left 4px
              font-family PingFangSC-Regular
        &-operate
          font-size 12px
          font-weight 400
          line-height 12px
          color #999
    .default-status
      display flex
      flex-direction column
      justify-content center
      align-items center
      margin-top 48px
      &-icon
        height 100px
        width 100px
        margin-bottom 16px
      &-text
        font-family PingFangSC-Regular
        font-size 13px
        font-weight normal
        line-height 13px
        color #999
  .footer
    margin 0 20px 44px 20px
    .operate-button
      background #FF6400
      width 100%
      padding 17px 0
      font-family PingFangSC-Semibold
      font-size 16px
      font-weight 600
      line-height 16px
      text-align center
      color #fff
      border-radius 10px
      &.disabled
        opacity 0.3
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mec3e5310"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./ticket-operate-drawer.mpx.js?isComponent&outputPath=components%2Fticket-operate-drawerec3e5310%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./ticket-operate-drawer.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fticket-operate-drawerec3e5310%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mec3e5310"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/ticket-operate-drawerec3e5310/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'Tab':getComponent(require("../../../components/tab.mpx?isComponent&outputPath=components%2Ftab6186cc86%2Findex")),'Checkbox':getComponent(require("./checkbox.mpx?isComponent&outputPath=components%2Fcheckbox236f9558%2Findex")),'controllable-drawer-bottom':getComponent(require("../../../components/controllable-drawer-buttom.mpx?isComponent&outputPath=components%2Fcontrollable-drawer-buttomcb57d2b4%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
